module.exports = __webpack_public_path__ + "img/img17.10b8097d.png";